import script from "./GiftFormBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftFormBlock.vue?vue&type=script&setup=true&lang=js"

import "./GiftFormBlock.vue?vue&type=style&index=0&id=503e1681&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-503e1681"]])

export default __exports__